var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDummySquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.2002V14.8002C6 15.9203 6 16.4801 6.21799 16.9079C6.40973 17.2842 6.71547 17.5905 7.0918 17.7822C7.5192 18 8.07899 18 9.19691 18H14.8031C15.921 18 16.48 18 16.9074 17.7822C17.2837 17.5905 17.5905 17.2842 17.7822 16.9079C18 16.4805 18 15.9215 18 14.8036V9.19691C18 8.07899 18 7.5192 17.7822 7.0918C17.5905 6.71547 17.2837 6.40973 16.9074 6.21799C16.4796 6 15.9203 6 14.8002 6H9.2002C8.08009 6 7.51962 6 7.0918 6.21799C6.71547 6.40973 6.40973 6.71547 6.21799 7.0918C6 7.51962 6 8.08009 6 9.2002Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummySquare);
export default __webpack_public_path__ + "static/media/Dummy_Square.544f5c72a1170782fb671de185ed4f71.svg";
export { ForwardRef as ReactComponent };